const partners = new Swiper(".partners", {
  spaceBetween: 40,
  slidesPerGroup: 1,
  loop: true,
  allowTouchMove: false,
  slidesOffsetAfter: 0,
  loopFillGroupWithBlank: false,

  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
    pauseOnMouseEnter: false,
  },
  breakpoints: {
    0: {
      slidesPerView: 2,
    },
    768: {
      slidesPerView: 3,
    },
    1200: {
      slidesPerView: 4,
    },
    1400: {
      slidesPerView: 5,
    },
  },
});

const reviewsLoop = new Swiper(".reviews-loop", {
  loop: true,
  mousewheel: false,
  speed: 14000,
  spaceBetween: 30,
  allowTouchMove: false,
  freeMode: false,
  freeModeMomentum: false,

  autoplay: {
    delay: 1,
    disableOnInteraction: false,
  },
  breakpoints: {
    0: {
      slidesPerView: 1.15,
    },
    768: {
      slidesPerView: 2.25,
    },
    1200: {
      slidesPerView: 3.35,
    },
    1440: {
      slidesPerView: 4.35,
    },
  },
});
